import { NgModule } from '@angular/core';
import { DatatablesModule, FormsModule, MenuService, PluginService, SupportModule } from '@kaiser-software/chassis-core';
import { Components } from './components';
import { Modals } from './modals';
import { Pages } from './pages';
import { Plugins } from './plugins';
import { Services } from './services';

@NgModule({
    imports: [],
    exports: []
})
export class CommentsBootstrapModule {

    constructor(private menuService: MenuService, private pluginService: PluginService) {
        const sidebar = menuService.get('sidebar');
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/comments-bootstrap.module.ts